{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Šablóny",
    "DESCRIPTION": "Zobrazte šablóny správ synchronizované z vašich schránok WhatsApp. Šablónu vytvoríte alebo upravíte u svojho poskytovateľa.",
    "COUNT": "Počet šablón: {n}",
    "LEARN_MORE": "Zistiť viac o šablónách WhatsApp",
    "SYNC_TEMPLATES": "Synchronizovať šablóny",
    "SYNC_SUCCESS": "Synchronizácia šablón sa spustila pre všetky schránky WhatsApp. Aktualizácia môže trvať niekoľko minút.",
    "PARTIAL_SYNC_ERROR": "Synchronizácia šablón sa spustila pre niektoré schránky WhatsApp, ostatné sa nepodarilo synchronizovať.",
    "SYNC_ERROR": "Synchronizáciu šablón sa nepodarilo spustiť. Skúste to prosím znova.",
    "SEARCH_PLACEHOLDER": "Hľadať podľa obsahu alebo názvu...",
    "MANAGE_IN_META": "Spravovať v Meta",
    "LOADING": "Načítavajú sa šablóny WhatsApp...",
    "EMPTY": "Nenašli sa žiadne šablóny WhatsApp.",
    "NO_RESULTS": "Filtrom nezodpovedá žiadna šablóna.",
    "FETCH_ERROR": "Šablóny WhatsApp sa nepodarilo načítať. Skúste to prosím znova.",
    "PARTIAL_FETCH_ERROR": "Niektoré šablóny WhatsApp sa nepodarilo načítať. Skúste to prosím znova.",
    "LAST_SYNC_ATTEMPT": "Posledný pokus o synchronizáciu {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "Neodoslané na schválenie WhatsApp"
    },
    "FILTERS": {
      "ALL_INBOXES": "Všetky schránky",
      "ALL_LANGUAGES": "Všetky jazyky",
      "ALL_TYPES": "Všetky typy"
    },
    "TYPES": {
      "TEXT": "Text",
      "IMAGE": "Obrázok",
      "VIDEO": "Video",
      "DOCUMENT": "Dokument",
      "CALL_TO_ACTION": "Výzva na akciu",
      "COPY_CODE": "Kopírovať kód"
    },
    "PREVIEW": {
      "TITLE": "Náhľad šablóny",
      "DESCRIPTION": "Náhľad, ako táto šablóna vyzerá vo WhatsApp.",
      "OPEN": "Náhľad {name}",
      "CLOSE": "Zavrieť náhľad",
      "DETAILS": "Podrobnosti šablóny",
      "STATUS": "Stav",
      "TYPE": "Typ obsahu",
      "CATEGORY": "Kategória",
      "LANGUAGE": "Jazyk",
      "INBOXES": "Schránky"
    }
  }
}
